import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { createRuleAsync } from "../../Helpers/API/RuleApi";
import RuleForm from "./RuleForm";

const CreateRule = () => {
	const navigate = useNavigate();
	const formValues = {
		name: "",
		field: "",
		operator: "",
		value: "",
		displayValue: "",
	};

	const onSubmit = (ruleObject) => {
		async function createRule() {
			const success = await createRuleAsync(ruleObject);
			if (success) navigate("/rules");
		}
		createRule();
	};

	return (
		<div>
			<div className="breadcrumbs">
				<Breadcrumb>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						Home
					</Breadcrumb.Item>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/rules" }}>
						Rules
					</Breadcrumb.Item>
					<Breadcrumb.Item active>New Rule</Breadcrumb.Item>
				</Breadcrumb>
			</div>
			<RuleForm initialValues={formValues} saveText="Create rule" headerText="Create a new rule" onSubmit={onSubmit} />
		</div>
	);
};

export default CreateRule;
